import React, { FC, MouseEventHandler } from 'react';

interface LineChartButtonProps {
  className: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const LineChartButton: FC<LineChartButtonProps> = ({ className, onClick }) => {
  return (
    <button onClick={onClick} className={`btn btn-primary btn-sm ${className}`} type="button">
      <span className="fa fa-line-chart"></span>
    </button>
  );
};